import Clickable from 'atoms/Clickable/Clickable';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import AssetWrapper from 'src/app/atoms/Asset/AssetWrapper';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';

export interface MegaMenuLearnMoreProps {
  image: IGatsbyImageData;
  alt: string;
  title: string;
  description: string;
  href: string;
}

const MegaMenuLearnMore = ({ image, alt, title, description, href }: MegaMenuLearnMoreProps): JSX.Element => {
  return (
    <Clickable href={href}>
      <Stack
        direction='row'
        directionLg='column'
        align='flex-start'
        justify='flex-start'
        gap='spacing-lg'
        padding='spacing-lg'
      >
        <AssetWrapper
          className='learn-more-image'
          maxWidth={144}
          radius='radius-sm'
          imageProps={{
            image,
            alt,
          }}
        />
        <Stack
          direction='column'
          align='flex-start'
          justify='flex-start'
          gap='spacing-xs'
        >
          <Typography
            type='paragraph'
            size='md'
            fontWeight='font-weight-semibold'
            color='text-primary'
          >
            {title}
          </Typography>
          <Typography
            type='paragraph'
            size='sm'
            color='text-tertiary'
          >
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Clickable>
  );
};

export default MegaMenuLearnMore;
